import { PageContentStatus } from 'core/type/PageContentStatus';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { createSelector } from '@reduxjs/toolkit';
import {
    selectActivityIdFromBootstrap,
    selectConfigFromBootstrap,
    selectExperimentsFromBootstrap,
    selectFeatureBehaviorFromBootstrap,
    selectLoyaltySearchTypeFromBootstrapState,
    selectPrerenderStateFromBootstrap,
} from 'store/slice/bootstrap';
import { selectActivityFromDetailState, selectDetailState, selectPageContentStatus } from 'component/page/detail/store/detail.selectors';
import { selectAvailabilitySelectedDate } from 'component/page/detail/store/availabilitySelectorIndex';
import { LoyaltySearchType } from 'core/type/LoyaltySearch.types';
import { ActivityWithContent } from 'gql/autogen/ActivityWithContent';
import { selectScreenSize } from 'store/slice/screen';
import { isAndroid, isIos } from 'core-framework/DeviceInfo/DeviceInfo';
import { Origin } from 'core/constant/Origin';

interface StateProps {
    config: BootstrapConfig;
    contentStatus: PageContentStatus;
    isLoading: boolean;
    activityId: number;
    activity: ActivityWithContent;
    loyaltySearchType: LoyaltySearchType;
    isPrerender: boolean;
    isSearchBoxFeatureGroup: boolean;
    isDesktop: boolean;
    isContinueYourBookingFeature: boolean;
    selectedDate?: Date;
    isDisableActivitiesForCnOrigin: boolean;
}

export type DetailsPageProps = StateProps;

export const mapStateToProps = createSelector(
    selectConfigFromBootstrap,
    selectDetailState,
    selectActivityFromDetailState,
    selectPageContentStatus,
    selectAvailabilitySelectedDate,
    selectLoyaltySearchTypeFromBootstrapState,
    selectActivityIdFromBootstrap,
    selectExperimentsFromBootstrap,
    selectPrerenderStateFromBootstrap,
    selectFeatureBehaviorFromBootstrap,
    selectScreenSize,
    (config, state, activity, contentStatus, selectedDate, loyaltySearchType, activityId, experiments, isPrerender, featureBehaviours, screenSize): StateProps => {
        const isSearchBoxFeatureGroup = featureBehaviours.SearchBoxFeatureGroup;
        const isContinueYourBookingFeature = featureBehaviours.ContinueYourBooking;
        const isDesktop = screenSize.desktop;
        const isChinaOrigin = (config.pageConfig.origin as Origin) === Origin.CN;
        const isDisableActivitiesForCnOrigin =
            isChinaOrigin &&
            ((!config.browser.isWebView && !featureBehaviours.EnableActivitiesForCnOriginWeb) ||
                (isAndroid() && config.browser.isWebView && !featureBehaviours.EnableActivitiesForCnOriginAndroid) ||
                (isIos() && config.browser.isWebView && !featureBehaviours.EnableActivitiesForCnOriginIos));

        return {
            config,
            contentStatus,
            selectedDate,
            activityId,
            activity,
            loyaltySearchType,
            isPrerender,
            isSearchBoxFeatureGroup,
            isDesktop,
            isContinueYourBookingFeature,
            isLoading: state.isLoading,
            isDisableActivitiesForCnOrigin,
        };
    },
);
